import {useRecoilState} from "recoil";
import {states} from "@recoils";
import {api, axiosUtil, cookieUtil} from "@utils";
import {useEffect} from "react";

const expire = 365;

export default function useAdminLogin() {
  const [userData, setUserData] = useRecoilState(states.userDataState);

  async function login(code: string) {
    const response = {
      success: false,
      message: "오류가 발생했습니다.",
    };

    try {
      const {data, message, success} = await api.v1.user.login({
        sns_type: "kakao",
        sns_token: code,
      });

      if (success) {
        cookieUtil.setCookie({
          name: axiosUtil.cookie_user_token_key,
          value: data.token.accessToken,
          expire,
        });
        getUserData();
        response.success = true;
        response.message = "로그인 성공";
      } else {
        response.message = message || "오류가 발생했습니다";
      }
    } catch (error) {
      console.error("useLogin login error", error);
    }
    return response;
  }

  async function getUserData() {
    try {
      const {data, success, message} = await api.v1.user.getUser();
      if (success) {
        cookieUtil.setCookie({
          name: axiosUtil.cookie_user_token_key,
          value: data.token.accessToken,
          expire,
        });
        setUserData(data.result);
      } else {
        throw Error(message);
      }
    } catch (error) {
      console.error("useLogin getUserData error", error);
      logout();
    }
  }

  function logout() {
    cookieUtil.deleteCookie({name: axiosUtil.cookie_user_token_key});
    setUserData(undefined);
  }

  useEffect(() => {
    if (!userData) {
      const cookie = cookieUtil.getCookie({
        name: axiosUtil.cookie_user_token_key,
      });
      if (cookie) {
        getUserData();
      }
    }
  }, []);

  return {
    login,
    logout,
    userData,
    getUserData,
    token: cookieUtil.getCookie({name: axiosUtil.cookie_user_token_key}),
  };
}
